import { makeStyles } from '@material-ui/core/styles';
import { TextColors, TextOpacities, SecondaryColors } from '@/utils/constants';
import { hexToRGBA } from '@/utils/helpers';

const darkTheme = {
  card: {
    color: TextColors.light,

    '& $content': {
      color: TextColors.light,
    },

    '& $date': {
      color: hexToRGBA(TextColors.light, TextOpacities.light1),
    },

    '& $copy': {
      color: hexToRGBA(TextColors.light, TextOpacities.light1),
    },

    '& $category': {
      color: SecondaryColors.main,

      '&:hover': {
        color: SecondaryColors.light,
      },
    },

    '& $header': {
      color: hexToRGBA(TextColors.light, TextOpacities.light2),
    },
  },
};

const lightTheme = {
  card: {
    color: TextColors.dark,

    '& $content': {
      color: TextColors.dark,
    },

    '& $date': {
      color: hexToRGBA(TextColors.dark, TextOpacities.dark1),
    },

    '& $copy': {
      color: hexToRGBA(TextColors.dark, TextOpacities.dark1),
    },

    '& $category': {
      color: SecondaryColors.dark,

      '&:hover': {
        color: SecondaryColors.main,
      },
    },

    '& $header': {
      color: hexToRGBA(TextColors.dark, TextOpacities.dark2),
    },
  },
};

const useStyles = makeStyles(
  (muiTheme) => ({
    card: {
      '&.dark-theme': darkTheme.card,
      '&.light-theme': lightTheme.card,
      height: '100%',
      position: 'relative',
      display: 'flex',
      flexDirection: 'column',
    },
    link: {
      '&.MuiButtonBase-root': {
        height: '100%',
        width: '100%',
        top: 0,
        left: 0,
        position: 'absolute',
        zIndex: 1,
      },
    },
    cardHeader: {
      '&.MuiCardHeader-root': {
        marginLeft: 0,
        padding: muiTheme.spacing(4, 4, 2.5),
        [muiTheme.breakpoints.up('md')]: {
          padding: muiTheme.spacing(5.5, 6, 2.5),
        },

        '&:last-child': {
          paddingBottom: muiTheme.spacing(3),

          [muiTheme.breakpoints.up('md')]: {
            paddingBottom: muiTheme.spacing(6),
          },
        },
      },
    },
    content: {
      '&.MuiCardContent-root': {
        padding: muiTheme.spacing(0, 4, 4),
        flexGrow: 1,

        [muiTheme.breakpoints.up('md')]: {
          padding: muiTheme.spacing(0, 6, 6),
        },

        '&:first-child': {
          paddingTop: muiTheme.spacing(4),

          [muiTheme.breakpoints.up('md')]: {
            paddingTop: muiTheme.spacing(6),
          },
        },

        '&:last-of-type': {
          paddingBottom: muiTheme.spacing(4),

          [muiTheme.breakpoints.up('md')]: {
            paddingBottom: muiTheme.spacing(6),
          },
        },

        '&:not(:last-of-type)': {
          paddingBottom: muiTheme.spacing(2.5),
        },
      },
    },
    actions: {
      '&, &.MuiCardActions-root': {
        padding: muiTheme.spacing(0, 4, 4),
        display: 'flex',
        justifyContent: 'space-between',
        [muiTheme.breakpoints.up('md')]: {
          padding: muiTheme.spacing(0, 6, 6),
        },
      },
    },
    date: {},
    image: {
      height: 0,
      width: '100%',
      paddingTop: '56.25%',
      position: 'relative',

      '& picture': {
        position: 'absolute',
        top: 0,
      },

      '&:not(:first-child)': {
        marginTop: muiTheme.spacing(2.5),
      },

      '&:not(:last-child)': {
        marginBottom: muiTheme.spacing(4),

        [muiTheme.breakpoints.up('md')]: {
          marginBottom: muiTheme.spacing(5.5),
        },
      },
      '& > img': {
        height: '100%',
        width: '100%',
        objectFit: 'cover',
      },
    },
    titleLink: {
      display: 'block',
    },
    contentHeading: {
      '&.MuiTypography-root': {
        color: 'inherit',
        marginBottom: muiTheme.spacing(1.5),
      },
    },
    copy: {},
    primaryCTA: {
      marginTop: muiTheme.spacing(2),
    },
    category: {
      marginBottom: muiTheme.spacing(1),
      textDecoration: 'none',
    },
    divider: {
      padding: '0 8px',
    },
    headerWrapper: {
      marginBottom: muiTheme.spacing(1),
      display: 'flex',
      justifyContent: 'space-between',
      gap: '12px',
      '& .partner-only-wrapper': {
        minWidth: '93px',
        textAlign: 'right',
      },
    },
    footerWrapper: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      gap: '12px',
    },
    categories: {
      alignItems: 'baseline',
      display: 'flex',
      flexWrap: 'wrap',
      gap: '8px',

      '& > *': {
        flexShrink: 0,
      },
    },
    chip: {
      position: 'relative',
      zIndex: 2,
      margin: '0 !important', // the space chip was replaced by the gap of the container
    },
  }),
  { name: 'GenContentCard' },
);

export default useStyles;
